export const SET_NOTIFICATION = "SET_NOTIFICATION";

const action = {};

action.setNotification = (payload) => {
  return {
    type: SET_NOTIFICATION,
    payload,
  };
};

export default action;
